(() => {
  const dialog = document.getElementById('KilnListingInquiry');
  if (!dialog) return;

  const setField = (name, value) => {
    const field = dialog.querySelector(`[name="contact[${name}]"]`);
    if (field) field.value = value;
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.mp-hide-price-access-control-message-link');
    const card = link?.closest('[data-kiln-inquiry-card]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof dialog.showModal !== 'function') {
      window.location.assign(card.dataset.kilnUrl);
      return;
    }

    const title = card.dataset.kilnTitle || 'this kiln';
    const url = card.dataset.kilnUrl || '';
    dialog.querySelector('[data-kiln-inquiry-title]').textContent = title;
    setField('Product', title);
    setField('Product URL', url);
    setField('SKU', card.dataset.kilnSku || '');
    setField('body', `Inquiry about ${title} — ${url}`);

    if (!dialog.open) dialog.showModal();
    dialog.querySelector('input[name="contact[name]"]')?.focus();
  }, true);

  dialog.querySelector('[data-kiln-inquiry-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  if (dialog.querySelector('.kiln-listing-dialog__success, .errors')) dialog.showModal();
})();
